import StepAuth from './src/step-auth';

export default StepAuth;
